export function screamingSnakeCaseToTitleCase(input: string): string {
  return input
    .split('_')
    .filter(word => word.length > 0)
    .map(word => word.toLowerCase())
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Retrieves the value of a specific cookie by its name.
 *
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string | null} - The value of the cookie if found, or an empty string if not found.
 *
 * @example
 * // Assuming document.cookie = "user=JohnDoe; theme=dark";
 * const user = getCookieValue('user'); // Returns "JohnDoe"
 * const theme = getCookieValue('theme'); // Returns "dark"
 * const nonExistent = getCookieValue('nonExistent'); // Returns ""
 */
export function getCookieValue(cookieName: string): string | null {
  // Split the document.cookie string into individual cookies
  const cookies = document.cookie.split(';');

  // Iterate through each cookie
  for (const cookie of cookies) {
    // Split the cookie into name and value
    const [name, value] = cookie.trim().split('=');

    // Check if the current cookie name matches the requested name
    if (name === cookieName) {
      // Decode and return the cookie value
      return decodeURIComponent(value);
    }
  }

  // Return an empty string if the cookie is not found
  return '';
}
